// External libraries
import React from 'react';
import { useStoreState } from '@/store';
import {
  FloatingLabelSelect,
  // @ts-expect-error untyped-import
} from '@checkout/react-components';

// Internal modules
import { getContent, getLocale } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';
import { LoadingElement } from '@/components/Common';

export type CountryOfResidenceProps = {
  blurHandler: (e: React.FocusEvent<HTMLInputElement>) => void;
  changeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
  focusHandler?: (e: React.FocusEvent<HTMLInputElement>) => void;
  shouldFocusOnRender?: boolean;
};

const CountryOfResidence = (props: CountryOfResidenceProps): JSX.Element => {
  useMountLogging('CountryOfResidence');
  const countryOfResidence = useStoreState(
    ({ form }) => form.countryOfResidence,
  );
  const selectOptions = useStoreState(({ api }) => {
    const { locale } = getLocale();
    return api.griffinMetadata.territories[locale];
  });

  // If the territories list is not populated yet (from the initial
  // data GraphQL call), show the loading element
  if (!selectOptions?.length) {
    return <LoadingElement />;
  }

  return (
    <FloatingLabelSelect
      blurHandler={props.blurHandler}
      changeHandler={props.changeHandler}
      data-testid="countryOfResidence"
      focusHandler={props.focusHandler}
      id="countryOfResidence"
      label={getContent('fieldLabels.countryOfResidence')}
      name="countryOfResidence"
      required={true}
      selectOptions={selectOptions}
      {...countryOfResidence}
    />
  );
};

export { CountryOfResidence };
